import example1Orig from "../images/productExample/originalPhoto1.jpg";
import example1 from "../images/productExample/example1.jpg";
import example2Orig from "../images/productExample/originalPhoto2.jpg";
import example2 from "../images/productExample/example2.jpg";
import example3Orig from "../images/productExample/originalPhoto3.jpg";
import example3 from "../images/productExample/example3.jpg";
import example4Orig from "../images/productExample/originalPhoto4.jpg";
import example4 from "../images/productExample/example4.jpg";
import example5Orig from "../images/productExample/originalPhoto5.jpg";
import example5 from "../images/productExample/example5.jpg";

import example7Orig from "../images/productExample/originalPhoto7.jpg";
import example7 from "../images/productExample/example7.jpg";
import example8Orig from "../images/productExample/originalPhoto8.jpg";
import example8 from "../images/productExample/example8.jpg";
import example9Orig from "../images/productExample/originalPhoto9.jpg";
import example9 from "../images/productExample/example9.jpg";
import example10Orig from "../images/productExample/originalPhoto10.jpg";
import example10 from "../images/productExample/example10.jpg";
import example11Orig from "../images/productExample/originalPhoto11.jpg";
import example11 from "../images/productExample/example11.jpg";
import example12Orig from "../images/productExample/originalPhoto12.jpg";
import example12 from "../images/productExample/example12.jpg";

export const categoryColors = {
  Cartoon: "#8B5CF6",
  Neon: "#EC4899",
  Adventurer: "#8B5CF6",
  Urban: "#8B5CF6",
  Elegant: "#8B5CF6",
  Glamour: "#EC4899",
  Culinary: "#8B5CF6",
  "Chef": "#8B5CF6",
  Winter: "#3B82F6",
  Ice: "#3B82F6",
  "Musical Performer": "#8B5CF6",
  "Desert Traveler": "#8B5CF6",
  Automotive: "#8B5CF6",
  Gentleman: "#8B5CF6",
  "Lifestyle": "#8B5CF6",
  "Art Style": "#8B5CF6",
  Musical: "#8B5CF6",
  Favorite: "#F59E0B",
};

export const ourProductExamples = [
  {
    id: 1,
    originalImage: example1Orig,
    stylizedImage: example1,
    category: "Watercolor",
    subcategory: "New York",
    description: "Watercolor greeting card with New York views",
  },
  {
    id: 2,
    originalImage: example2Orig,
    stylizedImage: example2,
    category: "Cartoon",
    subcategory: "Neon",
    description: "Cartoon greeting card with bright neon lighting",
  },
  {
    id: 3,
    originalImage: example3Orig,
    stylizedImage: example3,
    category: "Watercolor",
    subcategory: "Fishing",
    description: "Watercolor greeting card for fishing enthusiasts",
  },
  {
    id: 4,
    originalImage: example4Orig,
    stylizedImage: example4,
    category: "Anime",
    subcategory: "Christmas Tree",
    description: "Christmas greeting card in anime style with Christmas tree",
  },
  {
    id: 5,
    originalImage: example5Orig,
    stylizedImage: example5,
    category: "Western",
    subcategory: "Volleyball",
    description: "Sports greeting card in western style",
  },

  {
    id: 7,
    originalImage: example7Orig,
    stylizedImage: example7,
    category: "Line-art",
    subcategory: "Loft Office",
    description: "Minimalist greeting card in line-art style",
  },
  {
    id: 8,
    originalImage: example8Orig,
    stylizedImage: example8,
    category: "Cartoon",
    subcategory: "Wheat Stalks",
    description: "Cartoon greeting card with wheat stalks",
  },
    {
    id: 9,
    originalImage: example9Orig,
    stylizedImage: example9,
    category: "Oil Painting",
    subcategory: "Snowboards",
    description: "Winter greeting card in oil painting style",
  },
    {
    id: 10,
    originalImage: example10Orig,
    stylizedImage: example10,
    category: "Action",
    subcategory: "Audi A7",
    description: "Dynamic automotive greeting card in action style",
  },
    {
    id: 11,
    originalImage: example11Orig,
    stylizedImage: example11,
    category: "Cartoon",
    subcategory: "Money",
    description: "Financial greeting card in cartoon style",
  },
    {
    id: 12,
    originalImage: example12Orig,
    stylizedImage: example12,
    category: "Cartoon",
    subcategory: "Christmas Tree",
    description: "New Year cartoon greeting card with Christmas tree",
  },
  
];
